// Icon of a coin, or undefined when there is no picture for it. A bare
// require() of a missing file throws and takes the whole page down, and the
// pools add coins (RVN, ...) faster than icons get drawn.
export function coinIcon(code?: string | null): string | undefined {
  if (!code) {
    return undefined;
  }
  try {
    return require(`@/images/main/coins/${code}.png`);
  } catch {
    return undefined;
  }
}
